import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../../../contexts/ThemeContext'

function HeaderThemeSwitch() {
  const { toggleTheme, isDark } = useTheme()

  return (
    <div className="header-theme-switch switch__container">
      <input
        id="erp-header-theme-switch"
        className="switch switch--shadow"
        type="checkbox"
        checked={isDark}
        onChange={toggleTheme}
        aria-label={isDark ? 'Alternar para tema claro' : 'Alternar para tema escuro'}
      />
      <label htmlFor="erp-header-theme-switch">
        <Sun size={14} className="header-theme-switch-icon header-theme-switch-icon--sun" aria-hidden />
        <Moon size={14} className="header-theme-switch-icon header-theme-switch-icon--moon" aria-hidden />
      </label>
    </div>
  )
}

export default HeaderThemeSwitch
